import React, { Component } from 'react'
import injectSheet from 'react-jss'
import styles from './student-avatar.styles'
import Paper from 'pobble-components/dist/paper'
import Section from '../../../shared/section/section'
import Button from 'pobble-components/dist/button'
import {
  PobbleAvatar,
  STUDENT_AVATAR_COLORS_MAP,
  STUDENT_AVATAR_ICONS_MAP
} from 'pobble-components/dist/pobble-avatar'
import ArrowLeft from 'react-icons/lib/fa/arrow-left'
import ArrowRight from 'react-icons/lib/fa/arrow-right'

class StudentAvatar extends Component {
  constructor(props) {
    super(props)
    this.state = {
      icon: this.props.avatar.code,
      color: this.props.avatar.color,
      iconKeys: Object.keys(STUDENT_AVATAR_ICONS_MAP),
      colorKeys: STUDENT_AVATAR_COLORS_MAP,
      touched: false
    }
  }

  onPrevIcon = () => {
    let index = this.state.iconKeys.indexOf(this.state.icon)
    this.setState({
      icon: this.state.iconKeys[
        !index ? this.state.iconKeys.length - 1 : index - 1
      ],
      touched: true
    })
  }

  onNextIcon = () => {
    let index = this.state.iconKeys.indexOf(this.state.icon)
    this.setState({
      icon: this.state.iconKeys[
        index === this.state.iconKeys.length - 1 ? 0 : index + 1
      ],
      touched: true
    })
  }

  pickColor = color => {
    this.setState({ color, touched: true })
  }

  render() {
    const { classes, pending, id, displayName, onUpdate } = this.props
    return (
      <Paper className={classes.paper}>
        <Section
          pending={pending}
          title={'Choose your avatar'}
          className={classes.section}>
          <div className={classes.stage}>
            <Button
              action={this.onPrevIcon}
              secondary
              className={classes.arrow}>
              <ArrowLeft />
            </Button>
            <PobbleAvatar
              avatar={{
                type: 'StudentAvatar',
                code: this.state.icon,
                color: this.state.color
              }}
              name={displayName}
              className={classes.avatar}
            />
            <Button
              action={this.onNextIcon}
              secondary
              className={classes.arrow}>
              <ArrowRight />
            </Button>
          </div>
          <div className={classes.colors}>
            {Object.keys(this.state.colorKeys).map((key, index) => (
              <Button
                key={index}
                simple
                action={() => this.pickColor(key)}
                className={classes.color}>
                <span style={{ backgroundColor: this.state.colorKeys[key] }} />
              </Button>
            ))}
          </div>
          <div className={classes.action}>
            <Button
              className={classes.submitButton}
              disabled={!this.state.touched}
              action={() => onUpdate(id, this.state.color, this.state.icon)}
              big>
              Save
            </Button>
          </div>
        </Section>
      </Paper>
    )
  }
}

export default injectSheet(styles)(StudentAvatar)
